import { render } from "./PopUpNewCourse.vue?vue&type=template&id=136ff772"
import script from "./PopUpNewCourse.vue?vue&type=script&lang=js"
export * from "./PopUpNewCourse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__